import * as Control$dMonad$dCleanup from "../Control.Monad.Cleanup/index.js";
import * as Control$dMonad$dReader$dTrans from "../Control.Monad.Reader.Trans/index.js";
const $Slot = (_1, _2, _3) => ({tag: "Slot", _1, _2, _3});
const Slot = value0 => value1 => value2 => $Slot(value0, value1, value2);
const replaceSlot = v => v._1;
const newSlot = dict => dict.newSlot;
const destroySlot = v => v._2;
const appendSlot = v => v._3;
const monadReplaceReaderT = dictMonadReplace => {
  const MonadCleanup1 = dictMonadReplace.MonadCleanup1();
  const Monad0 = MonadCleanup1.Monad0();
  const map1 = Monad0.Bind1().Apply0().Functor0().map;
  const newSlot1 = dictMonadReplace.newSlot;
  const monadReaderT = Control$dMonad$dReader$dTrans.monadReaderT(Monad0);
  const monadCleanupReaderT = Control$dMonad$dCleanup.monadCleanupReaderT(MonadCleanup1);
  return {
    newSlot: (() => {
      const slotWith = env => slot => $Slot(
        m => slot._1(m(env)),
        slot._2,
        (() => {
          const $0 = slotWith(env);
          const $1 = slot._3;
          return () => {
            const a$p = $1();
            return $0(a$p);
          };
        })()
      );
      return env => map1(slotWith(env))(newSlot1);
    })(),
    Monad0: () => monadReaderT,
    MonadCleanup1: () => monadCleanupReaderT
  };
};
export {$Slot, Slot, appendSlot, destroySlot, monadReplaceReaderT, newSlot, replaceSlot};
